import { createApp } from 'vue';
import App from './App.vue';
import i18n from './libraries/i18n.js';
import Router from "./libraries/router.js";
import Store from "./store";

const app = createApp(App);
app.use(i18n);
app.use(Router);
app.use(Store);
app.mount("#app");